<app-stages [stages]="stages" currentStage="Lokalizacja"></app-stages>
<br>
<ng-container *ngIf='!pending() && !loading()'>
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <fieldset>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-0 mt-3">
            <div class="custom-radio custom-inline">
              <input (change)="form.provideRoadNumberAndNameChange(true)" name="provideRoadNumberAndName"
                     formControlName="provideRoadNumberAndName" type="radio"
                     id="provideRoadNumberAndNameTrue" [value]="true">
              <label for="provideRoadNumberAndNameTrue">
                Chcę wprowadzić numer i nazwę drogi
              </label>
            </div>
            <div class="custom-radio custom-inline">
              <input (change)="form.provideRoadNumberAndNameChange(false)" name="provideRoadNumberAndName"
                     formControlName="provideRoadNumberAndName" type="radio"
                     id="provideRoadNumberAndNameFalse" [value]="false">
              <label for="provideRoadNumberAndNameFalse">
                Chcę wprowadzić ulicę
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"city" as controlName'>
            <label [for]='controlName'>
              Miejscowość *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="form.cityChange()"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @if (form.provideRoadNumberAndName.value) {
                @for (item of form.townWithRoadsList(); track $index) {
                  <option [value]='item.name'>{{ item.name }}</option>
                }
              } @else {
                @for (item of form.townWithStreetsList(); track $index) {
                  <option [value]='item.name'>{{ item.name }}</option>
                }
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.roadNumber) {
          <div class='col-md-3'>
            <div class='form-group' *ngIf='"roadNumber" as controlName'>
              <label [for]='controlName'>
                Numer drogi *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                (change)="form.roadNumberChange(form.getElement($event).value)"
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @for (item of form.getRoadList(form.city.value); track $index) {
                  <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.roadName) {
          <div class='col-md-5'>
            <div class='form-group' *ngIf='"roadName" as controlName'>
              <label [for]='controlName'>
                Nazwa drogi *
              </label>
              <input
                readonly
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę drogi'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.street) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"street" as controlName'>
              <label [for]='controlName'>
                Ulica *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @for (item of form.getStreetList(form.city.value); track $index) {
                  <option [value]='item.roadNumber + " - " + item.name'>{{ item.roadNumber + " - " + item.name }}
                  </option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
    <br>
    <fieldset>
      <legend>
        Działki do których będzie prowadził zjazd przyległe do pasa drogowego
      </legend>
      <app-parcels-crud tag="parcels" formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <br>
    <fieldset>
      <legend>
        Informacje o nieruchomości
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"propertyLegalTitle" as controlName'>
            <label [for]='controlName'>
              Tytuł prawny do nieruchomości *
            </label>
            <select
              (change)="form.propertyLegalTitleChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item.id' *ngFor='let item of form.propertyLegalTitles()'>
                {{ item.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.propertyLegalTitleDesc) {
          <div class='col-md-6' *ngIf='"propertyLegalTitleDesc" as controlName'>
            <div class='form-group' *ngIf="form.get(controlName)">
              <label [for]='controlName'>
                Inny tytuł prawny *
              </label>
              <textarea
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu inny tytuł prawny'></textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"purposeOfUse" as controlName'>
            <label [for]='controlName'>
              Obecny sposób wykorzystania nieruchomości *
            </label>
            <select
              (change)="form.purposeOfUseChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of form.purposeOfUseList'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-6' *ngIf='"purposeOfUseDesc" as controlName'>
          <div class='form-group' *ngIf="form.get(controlName)">
            <label [for]='controlName'>
              Inny sposób *
            </label>
            <textarea
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu inny sposób'></textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      @if (!!form.postInvestmentUsage) {
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"postInvestmentUsage" as controlName'>
              <label [for]='controlName'>
                Sposób wykorzystania nieruchomości po wybudowaniu zjazdu *
              </label>
              <select
                (change)="form.postInvestmentUsageChange(form.getElement($event).value)"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option [value]='item' *ngFor='let item of form.postInvestmentUsages'>
                  {{ item }}
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-6' *ngIf='"propertyUsageChange" as controlName'>
            <div class='form-group' *ngIf="form.get(controlName)">
              <label [for]='controlName'>
                Zmiana wykorzystania nieruchomości *
              </label>
              <textarea
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Opisz tu zmiany wykorzystania nieruchomości'></textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      }
      @if (!!form.decisionNumber && !!form.decisionDate) {
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"decisionNumber" as controlName'>
              <label [for]='controlName'>
                Nr decyzji/uzgodnienia *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu numer decyzji/uzgodnienia'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"decisionDate" as controlName'>
              <label [for]='controlName'>
                Data decyzji/uzgodnienia *
              </label>
              <app-date-picker [id]='controlName' [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      }
      <div class="row">
        @if (form.referenceVehicleType) {
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"referenceVehicleType" as controlName'>
              <label [for]='controlName'>
                <br>Rodzaj pojazdu miarodajnego, <br> który będzie obsługiwał zjazd *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option value='Pojazd osobowy'>Pojazd osobowy</option>
                <option value='Pojazd komunalny'>Pojazd komunalny</option>
                <option value='Pojazd ciężarowy bez przyczepy'>Pojazd ciężarowy bez przyczepy</option>
                <option value='Pojazd ciężarowy z przyczepą'>Pojazd ciężarowy z przyczepą</option>
                <option value='Ciągnik rolniczy z dwiema przyczepami'>Ciągnik rolniczy z dwiema przyczepami</option>
                <option value='Autobus dwuosiowy'>Autobus dwuosiowy</option>
                <option value='Autobus trzyosiowy'>Autobus trzyosiowy</option>
                <option value='Autobus przegubowy'>Autobus przegubowy</option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.propertyParkingSpacesCount) {
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"propertyParkingSpacesCount" as controlName'>
              <label [for]='controlName'>
                Liczba stanowisk postojowych na <br> terenie nieruchomości do <br> której prowadził będzie zjazd *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                mask="0*"
                placeholder='Wpisz tu liczbe stanowisk'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
        <span>Wstecz</span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
</ng-container>
<app-spinner *ngIf='pending()'>
  Poczekaj trwa zapisywania danych...
</app-spinner>
<app-spinner *ngIf='loading()'>
  Poczekaj trwa ładowanie danych...
</app-spinner>
